import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { formatMilestoneDisplay, IMilestoneEvaluation } from '../../../lib/helpers/player-milestone.helpers';
import { PLAYER_MILESTONE_TYPE_LABELS } from '../../../lib/types';
import { MilestoneChartButton } from './milestone-chart-button.component';

interface IMilestoneDisplayRowProps {
  type: PlayerMilestoneType;
  metricValue: number | null;
  evaluation?: IMilestoneEvaluation;
}

// Read-only measurement row: label on the left, "metric / imperial" value on the
// right (e.g. `180 cm / 5'11"`). Renders an em dash when nothing recorded yet.
export const MilestoneDisplayRow: React.FC<IMilestoneDisplayRowProps> = ({ type, metricValue, evaluation }) => (
  <Box display="flex" alignItems="center" py={1.5} style={{ borderBottom: '1px solid #eee', gap: 8 }}>
    <Typography variant="body1" color="textSecondary" style={{ flexGrow: 1 }}>
      {PLAYER_MILESTONE_TYPE_LABELS[type]}
    </Typography>
    <Typography variant="body1" style={{ fontWeight: 600 }}>
      {metricValue == null ? '—' : formatMilestoneDisplay(type, metricValue)}
    </Typography>
    <MilestoneChartButton type={type} evaluation={evaluation} />
  </Box>
);
